import { asyncConnect } from 'redux-connect';
import { translate } from 'react-i18next';
import { createStructuredSelector } from 'reselect';

import {
  loadBike,
  loadBikePrices,
  createOrder,
  createTransaction,
  createStripeSetupIntent
} from 'actions';
import {
  orderBikeSelector,
  bikeTypesSelector,
  countriesSelector,
  currencySelector,
  orderBikeErrorSelector,
  orderBikeFetchingSelector
} from 'selectors';
import { isModeratorSelector } from 'selectors/profile';
import {
  createPromise,
  buildSearchParams,
  buildApiParams,
  isPromise
} from 'utils';

import DetailPage from './DetailPage';

const userProfileSelector = (state) => state.profile.profile;

const mapStateToProps = createStructuredSelector({
  user: userProfileSelector,
  currency: currencySelector,
  bike: orderBikeSelector,
  bikeError: orderBikeErrorSelector,
  bikeTypes: bikeTypesSelector,
  countries: countriesSelector,
  isFetching: orderBikeFetchingSelector,
  isModerator: isModeratorSelector
});

const mapDispatchToProps = {
  loadBike,
  createOrder,
  createTransaction,
  createStripeSetupIntent
};

export default asyncConnect(
  [{
    promise: ({
      store,
      helpers: { shouldWait },
      params: { bikeId },
      location: { query }
    }) => {
      if (!query) {
        return null;
      }

      const checkBikePrices = () => {
        const countries = countriesSelector(store.getState()) || [];

        const params = buildApiParams(buildSearchParams(query, countries));
        params.count = query.count || 1;
        params.extras = query.extras || '';

        return createPromise(
          store,
          shouldWait,
          () => false,
          loadBikePrices,
          bikeId,
          params
        );
      };

      let promise = createPromise(
        store,
        shouldWait,
        orderBikeSelector,
        loadBike,
        bikeId,
        undefined
      );

      if (!isPromise(promise)) {
        promise = checkBikePrices();
      } else {
        promise = promise.then(checkBikePrices);
      }

      return promise;
    }
  }],
  mapStateToProps,
  mapDispatchToProps
)(
  translate(['detail', 'extraItemTypes', 'translation'])(DetailPage)
);



// WEBPACK FOOTER //
// ./src/components/DetailPage/index.js